<!--
 * @Author: Zheng Lei
 * @Email: baimoc@163.com
 * @Date: 2020-08-11 15:01:49
 * @LastEditTime: 2021-06-24 12:18:08
 * @FilePath: \EmAtlas\src\components\BaimoFooter.vue
-->
<template>
    <div class="footer no-selected">
        <span><span class="el-icon-error"></span> 0</span>
        <span style="margin-left: 5px;"><span class="el-icon-warning"></span> 0</span>
        <span style="float: right; transform: scale(0.9);">{{raac_scheme}} | {{accession}}</span>
    </div>
</template>

<script>
    export default {
        name: "BaimoFooter",
        data() {
            return{
                raac_scheme: '',
            }
        },
        props: {
            accession: String,
        },
        watch: {
            '$store.state.raac_scheme'(val){
                this.raac_scheme = val.join("-");
            },
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                // console.log(this.$store.state.raac_scheme);
                this.raac_scheme = this.$store.state.raac_scheme.join("-");
            }
        }
    }
</script>

<style scoped>
    .footer {
        font-size: 8px;
        padding: 1px 5px 1px 15px;
        color: #4B6593;
        /*margin-top: 50px;*/
        background: #f8f8f8;
        border-top: 1px solid #e7e7e7;
        border-bottom: 1px solid #e7e7e7;
        height: 20px;
    }

    .no-selected {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .footer-dark {
        color: white;
        height: 4em;
        text-align: center;
        line-height: 40px;
        /*margin-top: 50px;*/
        background: #545C64;
        border-top: 0px solid #e7e7e7;
        border-bottom: 0px solid #e7e7e7;
        height: 40px;
    }

    .footer-dark a {
        color: #FFD04B
    }
</style>
